import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=6b35cc58&scoped=true&"
import script from "./file-list.vue?vue&type=script&lang=ts&"
export * from "./file-list.vue?vue&type=script&lang=ts&"
import style0 from "./file-list.vue?vue&type=style&index=0&id=6b35cc58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35cc58",
  null
  
)

export default component.exports